export enum MediaTypes {
  image = 'IMAGE',
  video = 'VIDEO',
}

export enum MediaTabNames {
  pictures = 'pictures',
  documents = 'documents',
}
